var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 10.8867C6.40668 10.8867 5.11334 9.5934 5.11334 8.00007C5.11334 6.40674 6.40668 5.1134 8.00001 5.1134C9.59334 5.1134 10.8867 6.40674 10.8867 8.00007C10.8867 9.5934 9.59334 10.8867 8.00001 10.8867ZM8.00001 6.1134C6.96001 6.1134 6.11334 6.96007 6.11334 8.00007C6.11334 9.04007 6.96001 9.88674 8.00001 9.88674C9.04001 9.88674 9.88668 9.04007 9.88668 8.00007C9.88668 6.96007 9.04001 6.1134 8.00001 6.1134Z",
    fill: "#0b8369"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.0134C5.49333 14.0134 3.12667 12.5467 1.5 10C0.793335 8.90003 0.793335 7.10669 1.5 6.00003C3.13333 3.45336 5.5 1.98669 8 1.98669C10.5 1.98669 12.8667 3.45336 14.4933 6.00003C15.2 7.10003 15.2 8.89336 14.4933 10C12.8667 12.5467 10.5 14.0134 8 14.0134ZM8 2.98669C5.84667 2.98669 3.78667 4.28003 2.34667 6.54003C1.84667 7.32003 1.84667 8.68003 2.34667 9.46003C3.78667 11.72 5.84667 13.0134 8 13.0134C10.1533 13.0134 12.2133 11.72 13.6533 9.46003C14.1533 8.68003 14.1533 7.32003 13.6533 6.54003C12.2133 4.28003 10.1533 2.98669 8 2.98669Z",
    fill: "#0b8369"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.d120d7411f31932cca566abc0003d020.svg";
export { ForwardRef as ReactComponent };